import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container } from '@ttstr/components';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container className="text-left">
      <Row>
        <Col md={{ size: 4, offset: 0 }}>
          <h5>Links</h5>
          <ul className="list-unstyled">
            <li>
              <a href="https://www.instagram.com/bilderbuchmusik/?hl=de">Instagram</a>
            </li>
            <li>
              <a href="https://www.tiktok.com/@bilderbuchmusik">TikTok</a>
            </li>
            <li>
              <a href="https://open.spotify.com/artist/2ErWLckuGFl84nGmg5fwyG">Spotify</a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCZXCfEevpX1wOKO6a8egX3Q">YouTube</a>
            </li>
            <li>
              <a href="https://bilderbuch.bandcamp.com/">Bandcamp</a>
            </li>
          </ul>
          <h5>{t(`FOOTER.HEAD1`)}</h5>
          <ul className="list-unstyled">
            <li>
              <Link to="/imprint">{t(`IMPRINT.TITLE`)}</Link>
            </li>
            <li>
              <Link to="/privacy">{t(`PRIVACY.TITLE`)}</Link>
            </li>
            <li>
              <Link to="/terms">{t(`TERMS_AND_CONDITIONS.TITLE`)}</Link>
            </li>
            <li>
              <a href="https://tickettoaster.de/retouren">Informationen zu Versand und Rückgabe</a>
            </li>
          </ul>
        </Col>
        {/* eslint-disable react/jsx-no-literals */}
        <Col md="4">
          <h5>{t(`FOOTER.HEAD2`)}</h5>
          <p>Du hast Fragen zu deiner Bestellung? Unser Support hilft dir gerne weiter:</p>
          <p>
            <h5>teamtoaster Support</h5>
            Tel.: +49 561 350 296 28 - 0<br />
            <a href="mailto:hallo@tickettoaster.de">hallo@tickettoaster.de</a>
          </p>
        </Col>
        {/* <Col md="4" className="text-sm-right"></Col> */}
        <Col md="4" className="align-items-end mt-2 text-right">
          <a href="https://tickettoaster.de" target="_blank" rel="noreferrer noopener">
            <img
              src={require('@ttstr/assets/images/logo_teamtoaster_full_white.png')}
              alt="powered by tickettoaster"
              title="powered by tickettoaster"
              width="133px"
              loading="lazy"
            />
          </a>
        </Col>
        {/* eslint-enable react/jsx-no-literals */}
      </Row>
    </Container>
  );
};

export default React.memo(Footer);
